import gql from 'graphql-tag';

export const markCardsViewed = gql`
  mutation MarkCardsViewedMutation($channelId: Int!) {
    createClientEvent(input: { channelId: $channelId, event: CARDS_VIEWED }) {
      id
    }
  }
`;

export const createCardExport = gql`
  mutation CreateCardExportMutation($input: CreateCardExport!) {
    createCardExport(input: $input) {
      url
    }
  }
`;
